import { Path, Svg, View } from '@react-pdf/renderer';

type MultiColorDotsProps = {
    colors: string[];
};

const MultiColorDots = ({ colors }: MultiColorDotsProps) => {
    const renderMultiColorDots = (colors: string[]) => {
        if (!colors) {
            return null;
        }

        const anglePerColorSegment = 360 / colors.length;

        const generateColorSegmentPath = (startAngle: number, endAngle: number) => {
            const start = convertAngleToCoordinates(50, 50, 40, endAngle);
            const end = convertAngleToCoordinates(50, 50, 40, startAngle);

            return [`M 50 50`, `L ${start.x} ${start.y}`, `A 40 40 0 0 0 ${end.x} ${end.y}`, `Z`].join(' ');
        };

        const convertAngleToCoordinates = (
            centerX: number,
            centerY: number,
            radius: number,
            angleInDegrees: number,
        ) => {
            const angleOffset = -30; // Adjust this value to tilt the splitting
            const angleInRadians = ((angleInDegrees - 90 + angleOffset) * Math.PI) / 180.0;

            return {
                x: centerX + radius * Math.cos(angleInRadians),
                y: centerY + radius * Math.sin(angleInRadians),
            };
        };

        return (
            <Svg viewBox="0 0 100 100" width={23} height={23}>
                {colors.map((color, index) => {
                    const startAngle = index * anglePerColorSegment;
                    const endAngle = startAngle + anglePerColorSegment;
                    const pathData = generateColorSegmentPath(startAngle, endAngle);
                    return <Path key={index} d={pathData} fill={color} stroke="gray" />;
                })}
            </Svg>
        );
    };

    return <View>{renderMultiColorDots(colors)}</View>;
};

export default MultiColorDots;
